// React Third Party Library
import { Col, Drawer, Form, Input, Row, Select, message } from "antd";
import { useDispatch, useSelector } from "react-redux";

// Constants Library

// Components Library
import DrawerEmployer from "../DrawerEmployer";

// Handler Library

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../services/util";

// Redux Library
import * as REDUX_ACTION from "../../../../services/redux/actions";
import { useEffect } from "react";

const { reduxStoreWrapper } = REDUX_UTIL;

export const DrawerCreateEmployer = (props) => {
  const { isOpen, setIsOpen } = props;
  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const [messageApi, contextHolder] = message.useMessage();

  const user = useSelector(reduxStoreWrapper("user"));

  const createEmployer = () => {
    form
      .validateFields()
      .then((values) => {
        messageApi.open({
          type: "loading",
          content: "Create Employer",
          duration: 0,
        });

        const employerData = {
          ...values,
          contact: `+60${values.contact}`,
          createdBy: user.memid,
        };

        dispatch(
          REDUX_ACTION.v1_employer.create_employer(employerData, () => {
            messageApi.destroy();
          })
        );
        form.resetFields();
      })
      .catch((err) => {
        message.error("fill the form");
      });
  };
  return (
    <>
      {contextHolder}
      <DrawerEmployer
        form={form}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        type="create"
        handleSave={createEmployer}
      />
    </>
  );
};

export const DrawerEditEmployer = (props) => {
  const { isOpen, setIsOpen, data, company } = props;
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      const contactWithoutPrefix = data?.contact.replace("+60", "");
      form.setFieldsValue({
        ...data,
        contact: contactWithoutPrefix,
      });
    }
  }, [isOpen]);

  const handleSave = () => {
    form
      .validateFields()
      .then((record) => {
        const formData = {
          uid: data.uid,
          updatedBy: data.uid,
          items: { ...data, ...record, contact: `+60${record.contact}` },
        };

        messageApi.open({
          type: "loading",
          content: "Updating...",
          duration: 0,
        });
        dispatch(
          REDUX_ACTION.v1_employer.update_employer_request(formData, () => {
            messageApi.destroy();
            setIsOpen(false);
          })
        );
      })
      .catch((err) => {
        message.error("fill the form");
      });
  };

  return (
    <>
      {contextHolder}
      <DrawerEmployer
        form={form}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        type="edit"
        handleSave={handleSave}
      />
    </>
  );
};
